import { makeAutoObservable, runInAction } from 'mobx'
import type { IResponseNumber } from 'entities/Phone/api/types'
import { NumbersListStore, PhoneApi } from 'entities/Phone'
import { IntegrationsApi } from 'entities/Integrations'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { type IAssignType } from 'entities/Phone/ui/AssignNumberCommon/store/AssignNumberCommonStore'
import { NUMBER_TABLE_STORE_KEY_UNASSIGNED } from 'pages/settings/pages/numbers/constants/constants'

export type IOnCloseAssignInboxModalModalProps = {
  rejectAssignedNumbers?: IResponseNumber[]
  successAssignedNumbers?: IResponseNumber[]
  processedAssignedNumbers?: IResponseNumber[]
  assignType?: IAssignType
  rejectMessage?: string[] | null
}

export class UnassignedTableStore {
  private readonly _numbersListStore: NumbersListStore

  constructor(
    private readonly _onSuccessAssignNumber: () => void,
    private _entities: IEntitiesStore
  ) {
    makeAutoObservable(this)

    this._numbersListStore = new NumbersListStore(
      NUMBER_TABLE_STORE_KEY_UNASSIGNED,
      (params, options) =>
        PhoneApi.getUnassignedNumbers({ ...params, withLandline: true }, options),
      this._entities
    )
  }

  init = () => {
    this._numbersListStore.init()
  }

  rejectAssignedNumbers: IResponseNumber[] = []
  clearRejectAssignedNumbers = () => {
    this.rejectAssignedNumbers = []
  }
  onCloseAssignInboxModalModal = ({
    rejectAssignedNumbers,
    successAssignedNumbers,
    processedAssignedNumbers,
  }: IOnCloseAssignInboxModalModalProps) => {
    if (rejectAssignedNumbers?.length) {
      this.getAirCallLink()
      this._numbersListStore.tableStore.resetSelected()
      this._numbersListStore.loadData()
    } else if (successAssignedNumbers?.length) {
      this._onSuccessAssignNumber()
    }
    if (processedAssignedNumbers) {
      this._numbersListStore.tableStore.resetSelected()
    }
    this.rejectAssignedNumbers = rejectAssignedNumbers || []
  }

  airCallLink = ''
  getAirCallLink = async () => {
    if (this.airCallLink) return
    try {
      const { data } = await IntegrationsApi.getAirCallIntegrationLink()
      runInAction(() => {
        this.airCallLink = data
      })
    } catch (e) {
      console.error(e)
    }
  }

  get numbersListStore() {
    return this._numbersListStore
  }
}
